import AddPet from "@/views/pets/AddPet";
import LinkPet from "@/views/pets/LinkPet";
import PetFound from "@/views/pets/PetFound";
import UserDash from "@/views/user/UserDash";
import ThisCouldBe from "@/views/pets/ThisCouldBe"
export default [
  {
    path: '/dashboard/usuario',
    name: 'userDash',
    component: UserDash,
    meta: {
      title: 'Dashboard de usuario',
      requiresAuth: true,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/agregar-mascota',
    name: 'addPet',
    component: AddPet,
    meta: {
      title: 'Agregar mascotas',
      requiresAuth: true,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/modificar-mascota/:id',
    name: 'modifyPet',
    component: AddPet,
    meta: {
      title: 'Modificar mascotas',
      requiresAuth: true,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/linkpet/:id_pet',
    name: 'linkpet',
    component: LinkPet,
    meta: {
      title: 'Proteger',
      requiresAuth: true,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/found',
    name: 'PetFound',
    component: PetFound,
    meta: {
      title: 'Mascota Encontrada',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/aqui-estaria-tu-mascota',
    name: 'thisCouldBe',
    component: ThisCouldBe,
    meta: {
      title: 'Tu mascota aquí',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },
]
